import axios, { AxiosError, AxiosRequestConfig } from 'axios';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { SettingsStore } from 'src/stores/SettingsStore/SettingsStore';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
axios.interceptors.request.use(async (config: AxiosRequestConfig) => {
    return {
        ...config,
        headers: {
            ...config.headers,
            ...(await getAuthHeader()),
        },
    };
});

// Response Interceptor for handling 401 errors
axios.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
        if (error.response?.status === 401) {
            console.warn('Unauthorized, logging out...');
            AuthStore.logout();
        }

        return Promise.reject(error);
    },
);

const getAuthHeader = async () => {
    try {
        await SettingsStore.updateTokenIfNeed();
    } catch {
        AuthStore.authenticate();
    }

    if (SettingsStore.keycloak?.token) {
        return {
            Authorization: `bearer ${SettingsStore.keycloak.token}`,
        };
    }

    return {};
};
